import { MouseEvent, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Menu, MenuItem, IconButton } from '@material-ui/core';
import { BurgerMenuIcon } from '../controls/helpers';

const AdviserMenu = () => {
    const [anchor, setAnchor] = useState<HTMLSpanElement | null>(null);
    const history = useHistory();

    const handleOpen = (event: MouseEvent<HTMLElement>) => {
        setAnchor(event.currentTarget);
        event.preventDefault();
    }

    return <>
        <IconButton disableRipple aria-label="menu" onClick={handleOpen}>
            <BurgerMenuIcon menuOpen={!!anchor}/>
        </IconButton>
        <Menu
            keepMounted
            anchorEl={anchor}
            open={Boolean(anchor)}
            onClose={() => setAnchor(null)}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{ style: { minWidth: anchor?.clientWidth }}}>
            <MenuItem onClick={() => history.push('/adviser/authentication/signout')}>Log off</MenuItem>
        </Menu>
    </>
};
 
export default AdviserMenu;
